module.exports = __webpack_public_path__ + "img/vertical_4_2_8004.bb3e26b1.png";